"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var Button_1 = __importDefault(require("atomicComponents/atoms/Buttons/Button"));
var Card_1 = __importDefault(require("atomicComponents/atoms/Card/Card"));
var Separator_1 = __importDefault(require("containers/Tools/styles/Separator"));
var Text_1 = __importDefault(require("shared/components/Text"));
var chargebee_1 = require("utils/chargebee");
var UnlockReportCard = function (_a) {
    var isPaid = _a.isPaid;
    var _b = __read((0, chargebee_1.useOpenCheckout)(), 2), openCheckout = _b[0], isSending = _b[1];
    return ((0, jsx_runtime_1.jsx)(Card_1.default, __assign({ position: "sticky", top: 20, maxWidth: 300, mx: "auto" }, { children: isPaid
            ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(Text_1.default, __assign({ level: 1, sx: { mb: 1 } }, { children: (0, jsx_runtime_1.jsx)("strong", { children: "Welcome to your SaaS Audit report" }) })), (0, jsx_runtime_1.jsx)(Text_1.default, __assign({ level: "caption" }, { children: "We've broken down where you are overpaying and how you can save." }))] }))
            : ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(Text_1.default, __assign({ level: 1, sx: { my: 1 } }, { children: (0, jsx_runtime_1.jsx)("strong", { children: "Access the full report" }) })), (0, jsx_runtime_1.jsx)(Text_1.default, __assign({ level: "caption" }, { children: "Our SaaS audit analyses your spend and active subscriptions to show you exactly where you're overpaying and how you can save." })), (0, jsx_runtime_1.jsx)(Separator_1.default, {}), (0, jsx_runtime_1.jsx)(Button_1.default, __assign({ color: "secondary", fullWidth: true, sx: { mb: 1, color: 'common.white' }, onClick: function () { return openCheckout('Growth', 'Annual'); }, disabled: isSending }, { children: "Upgrade now" }))] })) })));
};
exports.default = UnlockReportCard;
